var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-title',{attrs:{"component-name":"v-area-picker","desc":"vue移动端地址选择器"}}),_vm._v(" "),_c('component-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }